export const OPTIONS = {
  FLOOR: "FLOOR",
  CEIL: "CEIL",
  ROUND: "ROUND"
};

export default function softRound(n, options = {}) {
  const sig = (options && options.sigFigs) || 1;
  const round = String(options && options.round).toUpperCase();

  if (isNaN(n) || n === 0 || n === null) {
    return n;
  }
  if (sig >= n.toString().length) {
    return n;
  }

  const prefix = n < 0 ? -1 : 1;
  n = Math.abs(n);

  var mult = Math.pow(10, sig - Math.floor(Math.log(n) / Math.LN10) - 1);

  let retValue;

  switch (round) {
    case OPTIONS.FLOOR:
      retValue = Math.floor(prefix * n * mult) / mult;
      break;
    case OPTIONS.CEIL:
      retValue = Math.ceil(prefix * n * mult) / mult;
      break;
    case OPTIONS.ROUND:
      retValue = Math.round(prefix * n * mult) / mult;
      break;
    default:
      retValue = Math.round(prefix * n * mult) / mult;
      break;
  }

  return retValue;
}
